import Box, { BoxProps } from '@mui/material/Box';
import { useState } from 'react';
import { AirshipIcon } from '../../icons';

type PublicImageProps = React.ImgHTMLAttributes<HTMLImageElement> & {
  sx?: BoxProps['sx'];
  basePublicFilesUrl: string;
  fallbackIcon?: React.ReactNode;
};

const PublicImg: React.FC<PublicImageProps> = ({
  src,
  sx,
  basePublicFilesUrl,
  fallbackIcon,
  ...props
}) => {
  const [showLogo, setShowLogo] = useState(true);

  return showLogo && src ? (
    <Box
      component="img"
      src={`${basePublicFilesUrl}${src}`}
      onError={() => setShowLogo(false)}
      sx={sx}
      {...props}
    />
  ) : (
    (fallbackIcon ?? <AirshipIcon height="6.5rem" />)
  );
};

export default PublicImg;
